import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import './cell-hover.scss';
import { compose } from 'redux';
import { componentLimit } from '../../../../configs/WidgetConfig';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import {
  checkIsBank,
  formatComGroupCode,
  isNotLoginOrExpired,
} from '../../../helpers/Common';
import Layout from '../../../helpers/Layout';
import { setDragPopup } from '../../../main-layout/reducer';
import { toggleModal } from '../../../app/reducer';
import Const from '../../../common/Const';
import Modal from '../../../common/securities-firms';
import AddToWatchList from './AddToWatchList';
import EventEmitter, { SHOW_GUEST_POPUP } from '../../../helpers/EventEmitter';

const { listComponent } = Const;

const items = [
  {
    componentName: listComponent.Alerts,
    content: `common.listComponent.${listComponent.Alerts}`,
    icon: 'icon-bell',
  },
  // {
  //   componentName: listComponent.FinancialAnalysis,
  //   content: `common.listComponent.${listComponent.FinancialAnalysis}`,
  //   icon: 'icon-inbox ',
  // },
  // {
  //   componentName: listComponent.TimeAndSales,
  //   content: `common.listComponent.${listComponent.TimeAndSales}`,
  //   icon: 'icon-clock',
  // },
  // {
  //   componentName: listComponent.PriceDepth,
  //   content: `common.listComponent.${listComponent.PriceDepth}`,
  //   icon: 'icon-trend',
  // },
  // {
  //   componentName: listComponent.News,
  //   content: `common.listComponent.${listComponent.News}`,
  //   icon: 'icon-list',
  // },
  {
    componentName: listComponent.FASnapshot,
    content: `common.listComponent.${listComponent.FASnapshot}`,
    icon: 'icon-camera1',
  },
  {
    componentName: listComponent.FinancialRatio,
    content: `common.listComponent.${listComponent.FinancialRatio}`,
    icon: 'icon-trend',
  },
  {
    componentName: listComponent.FADividendAnalysis,
    content: `common.listComponent.${listComponent.FADividendAnalysis}`,
    icon: 'icon-list',
  },
];

const LARGE_POPUP_HEIGHT = 253;
const MEDIUM_POPUP_HEIGHT = 231;
const SMALL_POPUP_HEIGHT = 215;

class CellHover extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowPopup: false,
      width: 0,
      height: 0,
      top: null,
      left: null,
      isShowTriangle: false,
    };
    this.el = document.createElement('div');
    this.div = document.createElement('div');
    this.rootRef = React.createRef();
    this.popupRef = React.createRef();
    this.iconRef = React.createRef();
    this.debouncedMouseMove = debounce(this.onMouseMove, 20);
    this.modalRef = React.createRef();
    this.componentRefs = {};
    items.forEach(item => {
      this.componentRefs[item.componentName] = React.createRef();
    });
    this.dragSources = [];
  }

  componentDidMount() {
    this.tr = this.rootRef.current.closest('tr');
    this.table = this.rootRef.current.closest('.scrollbars');
    this.setState({
      isShowTriangle: false, // !!document.getElementById('root'),
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { isShowPopup } = this.state;
    const { isShowSecuritiesFirmModal } = this.props;
    if (!prevState.isShowPopup && isShowPopup) {
      const { left, top } = this.calcPosition();
      this.setState({ left, top });
      this.createDragSource();
      this.shouldRemoveDragSource = true;
      const onTabCreated = () => {
        setTimeout(() => {
          this.removeDragSource();
        }, 0);
      };
      Layout.layout.on('tabCreated', onTabCreated);
      Layout.layout.on('componentCreated', () => {
        this.shouldRemoveDragSource = false;
      });
    }

    if (!isShowPopup && prevState.isShowPopup) {
      if (this.shouldRemoveDragSource) {
        this.removeDragSource();
      }

      try {
        document.body.removeChild(this.el);
      } catch (e) {}
    }

    if (!isShowSecuritiesFirmModal && prevProps.isShowSecuritiesFirmModal) {
      if (this.isShowSecuritiesFirmsModal) {
        document.body.removeChild(this.div);
        this.isShowSecuritiesFirmsModal = false;
      }
    }
  }

  removeDragSource = () => {
    this.dragSources.forEach(source => {
      source._dragListener.destroy();
    });
    this.dragSources = [];
  };

  createDragSource = () => {
    items.forEach(item => {
      const dragSource = Layout.drag(
        this.componentRefs[item.componentName].current,
        {
          title: item.componentName,
          name: item.componentName,
          tooltip: item.componentName,
        },
        { dragCode: this.getCode() },
      );
      this.dragSources.push(dragSource);
    });
  };

  getCode = () => {
    const { organCode, listOrganizationByOrganCode } = this.props;
    const organization = listOrganizationByOrganCode[organCode];

    return {
      ...organization,
      exchange: formatComGroupCode(organization.comGroupCode),
      isBank: checkIsBank(organization.comTypeCode),
    };
  };

  getTableHeight = () => {
    const lmItem = this.table.closest('.lm_item');
    const {
      bottom: tableBottom,
      top: tableTop,
    } = this.table.getBoundingClientRect();
    const { bottom: lmBottom } = lmItem.getBoundingClientRect();
    if (tableBottom > lmBottom) {
      return lmBottom - tableTop;
    }

    return tableBottom - tableTop;
  };

  getPopupHeight = () => {
    const { fontSize } = this.props;
    const map = {
      Large: LARGE_POPUP_HEIGHT,
      Medium: MEDIUM_POPUP_HEIGHT,
      Small: SMALL_POPUP_HEIGHT,
    };

    return map[fontSize];
  };

  calcPosition = () => {
    const { bottom: tableBottom } = this.table.getBoundingClientRect();
    const {
      bottom: rowBottom,
      top: rowTop,
      left: rowLeft,
    } = this.iconRef.current.getBoundingClientRect();
    const tableHeight = this.getTableHeight();
    const popupHeight = this.getPopupHeight();
    if (tableHeight > popupHeight && rowBottom + popupHeight < tableBottom) {
      const isShowTop = rowBottom + popupHeight > tableBottom;
      if (isShowTop) {
        return {
          left: rowLeft,
          top: rowTop - popupHeight,
        };
      }

      return {
        left: rowLeft,
        top: rowBottom,
      };
    }
    const main = document.querySelector('.fiintrade-main');
    const isShowTop =
      rowBottom + popupHeight > main.getBoundingClientRect().bottom;
    if (isShowTop) {
      return {
        left: rowLeft,
        top: rowTop - popupHeight,
      };
    }

    return {
      left: rowLeft,
      top: rowTop,
    };
  };

  onMouseDown = () => {
    this.setState({
      isShowPopup: false,
    });
  };

  showPopup = e => {
    e.preventDefault();
    this.setState({
      isShowPopup: true,
    });
    document.body.appendChild(this.el);
    document.body.appendChild(this.div);
    document.body.addEventListener('mousemove', this.debouncedMouseMove);
    this.tr.addEventListener('mousedown', this.onMouseDown);
  };

  onMouseMove = e => {
    const isInTr = this.tr && this.tr.contains(e.target);
    const isInModal =
      e.target === this.modalRef.current ||
      (this.modalRef.current && this.modalRef.current.contains(e.target));
    const isInPopup =
      this.popupRef.current && this.popupRef.current.contains(e.target);
    if (isInTr || isInPopup || isInModal) {
      return;
    }
    this.hideList();
    document.body.removeEventListener('mousemove', this.debouncedMouseMove);
    this.tr.removeEventListener('mousedown', this.onMouseDown);
    if (!this.isShowSecuritiesFirmsModal) {
      try {
        document.body.removeChild(this.div);
      } catch (e) {}
    }
  };

  showDragPopup = (item, organCode) => {
    const { setDragPopup } = this.props;
    this.hideList();
    setDragPopup({
      ...item,
      organCode,
      isShow: true,
    });
  };

  hideList = () => {
    this.setState({
      isShowPopup: false,
    });
  };

  isDisableDrag = item => {
    const { countListComponent } = this.props;
    const isLimit = componentLimit[item.componentName] === 1;
    const hasComponent =
      countListComponent[item.componentName] &&
      countListComponent[item.componentName] === 1;

    return isLimit && hasComponent;
  };

  showSecuritiesFirmsModal = () => {
    const { toggleModal } = this.props;
    this.setState({
      isShowPopup: false,
    });
    toggleModal(true);
    this.isShowSecuritiesFirmsModal = true;
  };

  renderChild = () => {
    const { isShowPopup, left, top } = this.state;
    const { organCode, isShowSecuritiesFirmModal } = this.props;
    const isShow = left && top && isShowPopup;
    return (
      <div
        ref={this.popupRef}
        style={{
          left,
          top,
          maxHeight: isShow ? 500 : 0,
        }}
        className="watchlist-popup"
      >
        {isShowSecuritiesFirmModal &&
          ReactDOM.createPortal(<Modal modalRef={this.modalRef} />, this.div)}
        <div className="watchlist-popup__header d-flex align-items-center justify-content-between">
          <div
            onClick={this.showSecuritiesFirmsModal}
            className="watchlist-popup__header--buy"
          >
            {I18n.t('common.buy')}
          </div>
          <div
            onClick={this.showSecuritiesFirmsModal}
            className="watchlist-popup__header--sell"
          >
            {I18n.t('common.sell')}
          </div>
        </div>
        <div className="watchlist-popup__body d-flex flex-column">
          {items.map(item => {
            const isDisableDrag = this.isDisableDrag(item);
            const onClick = isDisableDrag
              ? null
              : () => this.showDragPopup(item, organCode);
            return (
              <div
                ref={this.componentRefs[item.componentName]}
                key={item.componentName}
                onClick={onClick}
                className={`watchlist-popup__body--item ${
                  isDisableDrag ? 'disabled' : ''
                }`}
              >
                <i className={item.icon} />
                <Translate
                  value={`common.listComponent.${item.componentName}`}
                />
              </div>
            );
          })}
          <AddToWatchList organCode={organCode} />
        </div>
      </div>
    );
  };

  onClickDelete = (...args) => {
    const { handleDelete, user } = this.props;
    if (isNotLoginOrExpired(user)) {
      EventEmitter.dispatch(SHOW_GUEST_POPUP);
      return;
    }
    handleDelete(args);
  };

  render() {
    const { isShowTriangle } = this.state;
    const { children, isShowDeleteIcon, isShowQuickIcon } = this.props;
    const hasGoldenLayout = !!Layout.layout;

    return (
      <div
        style={{
          minWidth: 100,
          position: 'relative',
          zIndex: 22,
        }}
        className="d-flex align-items-center"
        ref={this.rootRef}
      >
        {children}
        <div className="mr-2 cell-hover-icon">
          <div className="d-flex">
            {isShowTriangle && isShowQuickIcon && hasGoldenLayout && (
              <div
                ref={this.iconRef}
                onClick={this.showPopup}
                className="circle d-flex justify-content-center align-items-center bg-b-color-6"
              >
                <div className="triangle-up" />
              </div>
            )}
            {hasGoldenLayout && isShowDeleteIcon && (
              <i
                className="icon-bin-delete text-b-color-6"
                onClick={this.onClickDelete}
              />
            )}
          </div>
        </div>
        {ReactDOM.createPortal(this.renderChild(), this.el)}
      </div>
    );
  }
}

CellHover.propTypes = {
  isShowDeleteIcon: PropTypes.bool,
  handleDelete: PropTypes.func,
  setDragPopup: PropTypes.func.isRequired,
  organCode: PropTypes.string,
  isShowQuickIcon: PropTypes.bool,
};

CellHover.defaultProps = {
  isShowDeleteIcon: true,
  handleDelete: () => {},
  organCode: '',
  isShowQuickIcon: true,
};

const mapStateToProps = state => ({
  i18n: state.i18n,
  countListComponent: state[COMMON_REDUCER_NAME].countListComponent,
  isShowSecuritiesFirmModal: state.isShowModal,
  listOrganizationByOrganCode:
    state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
  fontSize: state.fontSize,
  user: state.userInfo,
});

const mapDispatchToProps = {
  setDragPopup,
  toggleModal,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(CellHover);
